module.exports = __webpack_public_path__ + "img/fb5a2e4.png";